import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "security-ribbon"
}
const _hoisted_2 = { class: "security-ribbon__legend" }
const _hoisted_3 = { class: "security-ribbon__legend-message" }

import { ref } from 'vue';

import { ONBOARDING_VERIFICATION_STATUS_URL } from '@exchange/libs/account/service/src/lib/constants.config';


export default /*#__PURE__*/_defineComponent({
  __name: 'SecurityRibbon',
  setup(__props) {

const closed = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (!closed.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('modules.ribbons.verify.text')), 1),
          _createVNode(_component_x_button, {
            href: _unref(ONBOARDING_VERIFICATION_STATUS_URL),
            text: _ctx.$t('modules.ribbons.verify.button.text'),
            class: "legend__legend-button",
            "href-custom-icon": { name: 'verify' },
            size: "xs",
            variant: "primary"
          }, null, 8, ["href", "text"])
        ]),
        _createElementVNode("button", {
          class: "security-ribbon__close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closed.value = !closed.value))
        }, [
          _createVNode(_component_ot_icon, { name: "close" })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})